<template>
  <div class="app-page-toolbar">
    <router-link :to="{ path: '/stripe-charge/new' }" v-if="hasPermissionToCreate">
      <el-button icon="el-icon-fa-plus" type="primary">
        <app-i18n code="common.new"></app-i18n>
      </el-button>
    </router-link>

    <router-link :to="{ path: '/stripe-charge/import' }" v-if="hasPermissionToImport">
      <el-button icon="el-icon-fa-upload" type="primary">
        <app-i18n code="common.import"></app-i18n>
      </el-button>
    </router-link>

    <router-link
      :to="{ path: '/audit-logs', query: { entityNames: 'stripeCharge' } }"
      v-if="hasPermissionToAuditLogs"
    >
      <el-button icon="el-icon-fa-history">
        <app-i18n code="auditLog.menu"></app-i18n>
      </el-button>
    </router-link>

    <el-tooltip :content="exportButtonTooltip" :disabled="!exportButtonTooltip">
      <span>
        <el-button
          :disabled="exportButtonDisabled"
          @click="doExport()"
          icon="el-icon-fa-file-excel-o"
        >
          <app-i18n code="common.export"></app-i18n>
        </el-button>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { StripechargePermissions } from '@modules/stripe/stripe-charge/stripe-charge-permissions';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-stripe-charge-list-toolbar',

  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
      hasRows: 'stripeCharge/list/hasRows',
      loading: 'stripeCharge/list/loading',
      exportLoading: 'stripeCharge/list/exportLoading',
      selectedRows: 'stripeCharge/list/selectedRows',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToCreate() {
      return new StripechargePermissions(this.currentUser).create;
    },

    hasPermissionToEdit() {
      return new StripechargePermissions(this.currentUser).edit;
    },

    hasPermissionToImport() {
      return new StripechargePermissions(this.currentUser).import;
    },

    exportButtonDisabled() {
      return (
        !this.hasRows || this.loading || this.exportLoading
      );
    },

    exportButtonTooltip() {
      return !this.hasRows
        ? i18n('common.noDataToExport')
        : null;
    },

    removeButtonDisabled() {
      return !this.selectedRows.length || this.loading;
    },

    removeButtonTooltip() {
      return !this.selectedRows.length
        ? i18n('common.mustSelectARow')
        : null;
    },

    enableButtonDisabled() {
      return !this.selectedRows.length || this.loading;
    },

    enableButtonTooltip() {
      return !this.selectedRows.length
        ? i18n('common.mustSelectARow')
        : null;
    },

    disableButtonDisabled() {
      return !this.selectedRows.length || this.loading;
    },

    disableButtonTooltip() {
      return !this.selectedRows.length
        ? i18n('common.mustSelectARow')
        : null;
    },
  },

  methods: {
    ...mapActions({
      doExport: 'stripeCharge/list/doExport',
      doRemoveAllSelected:
        'stripeCharge/list/doRemoveAllSelected',
      doDisableAllSelected:
        'stripeCharge/list/doDisableAllSelected',
      doEnableAllSelected:
        'stripeCharge/list/doEnableAllSelected',
    }),
  },
};
</script>

<style>
</style>
